'use strict';

angular.module('far.profile')
    .controller('ProfileDischargeController', function (
        $rootScope,
        Notice,
        softdeleteable,
        pagination,
        form,
        autocomplete,
        $scope,
        $http
    ) {
        var vm = {
            form: {},
            submit: submit,
            fields: form('ProfileDischarge'),
            progress: false,
            submitted: false,
            user: null,
            userQualificationNotificationId: null,

            setId: setId,
            constructor: function (user) {
                vm.user = user;
            }
        };

        vm.fields
            .addField('user', 'uiSelect', {
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select',
                    ngRequired: 'field.uiSelectOptions.required()',
                    ngDisabled: 'field.uiSelectOptions.disabled()'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.fio }} ',
                    choicesTitle: '{{ item.fio }}',
                    match: {
                        placeholder: 'Альпинисты',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "user")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        vm.form.user = item;
                    },
                    required: function() {
                        return true;
                    },
                    disabled: function() {
                        return false;
                    }
                }
            }, autocomplete.get('user'))
            ;

        function submit() {
            vm.submitted = true;
            vm.show_error = true;

            $http.put(Routing.generate('api_put_user_qualification_notification', {userQualificationNotificationId: vm.userQualificationNotificationId, userId: vm.form.user.id}))
                .then(function (response) {
                    alert('Спасибо!');
                    document.location.reload();
                }, function errorCallback(response) {
                    $log.error(response);

                    vm.submitted = true;
                });

            vm.submitted = false;
        }

        function setId(id) {
            vm.userQualificationNotificationId = id;
        }

        return vm;
    });